module.exports = __webpack_public_path__ + "img/Reacondicionarte_parrafo_1.4f97d574.jpg";